import { EmailDelivery, EmailType, EMAIL_STATUS_LABELS, Registration } from "./types";

// Groups the email log by registration and boils statuses down to what the administrator acts on

export type DeliveriesByRegistration = Record<string, Partial<Record<EmailType, EmailDelivery>>>;

export const indexDeliveries = (deliveries: EmailDelivery[]): DeliveriesByRegistration => {
  const byRegistration: DeliveriesByRegistration = {};
  for (const delivery of deliveries) {
    (byRegistration[delivery.registrationId] ??= {})[delivery.emailType] = delivery;
  }
  return byRegistration;
};

/** done: handed to the email service (or simulated) · waiting: queued or sending · failed · none: never queued */
export type DeliveryTone = "done" | "waiting" | "failed" | "none";

export const deliveryTone = (delivery?: EmailDelivery): DeliveryTone => {
  if (!delivery) return "none";
  if (delivery.status === "sent" || delivery.status === "delivered" || delivery.status === "simulated") return "done";
  if (delivery.status === "failed" || delivery.status === "bounced") return "failed";
  return "waiting";
};

export const deliveryLabel = (delivery?: EmailDelivery) => (delivery ? EMAIL_STATUS_LABELS[delivery.status] : "Not sent");

/** A confirmation or joining email failed or bounced */
export const hasEmailIssue = (registration: Registration, deliveries: DeliveriesByRegistration) =>
  Object.values(deliveries[registration.id] ?? {}).some(delivery => deliveryTone(delivery) === "failed");

/** Already has the joining instructions: emailed (sent, delivered or simulated), or recorded as sent by hand */
export const hasJoiningInstructions = (registration: Registration, deliveries: DeliveriesByRegistration) =>
  deliveryTone(deliveries[registration.id]?.joining_instructions) === "done" || Boolean(registration.instructionsSentAt);

/** Joining-instruction progress for one webinar's registered (not cancelled or attended) attendees */
export function joiningSummary(registrations: Registration[], deliveries: DeliveriesByRegistration) {
  const summary = { registered: 0, done: 0, waiting: 0, failed: 0, none: 0 };
  for (const registration of registrations) {
    if (registration.status !== "registered") continue;
    summary.registered++;
    summary[deliveryTone(deliveries[registration.id]?.joining_instructions)]++;
  }
  return summary;
}
